import { Button, Flex } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import {
	useTranslationCapManage,
	useTranslationCommonUi,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

interface Props {
	showFilters: boolean;
	onToggleFilters: () => void;
}

export const DealEventLogActions = ({ showFilters, onToggleFilters }: Props) => {
	const tCapManage = useTranslationCapManage();
	const tCommonUi = useTranslationCommonUi();

	return (
		<Flex gap="0.5rem" align="center">
			<Button
				variant="default"
				fw={600}
				leftSection={<Icon variant="download-v3" size="vlg" />}
				data-testid="deal-event-log-export-csv"
			>
				{tCapManage('deal_event_log.export_csv')}
			</Button>

			<Button
				variant="default"
				fw={600}
				leftSection={<Icon variant="calendar-v3" size="vlg" />}
				data-testid="deal-event-log-jump-to-date"
			>
				{tCapManage('deal_event_log.jump_to_date')}
			</Button>

			<Button
				variant={showFilters ? 'light' : 'default'}
				fw={600}
				onClick={onToggleFilters}
				leftSection={<Icon variant="filter" size="vlg" />}
				data-testid="deal-event-log-toggle-filters"
			>
				{tCommonUi('mantine_table.top_toolbar.filters')}
			</Button>
		</Flex>
	);
};
